import { z } from 'zod';
import { UINT_8_ARRAY_SCHEMA } from '../../../../common/schema.ts';

export const POST_SCHEMA = z.object({
  rawId: UINT_8_ARRAY_SCHEMA,
  response: z.object({
    clientDataJSON: UINT_8_ARRAY_SCHEMA,
    attestationObject: UINT_8_ARRAY_SCHEMA,
  }),
});